import { connect } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { buildLoginPath } from "../app/utils/authRedirect";

export const ProtectedRoute = ({ auth, allowed }) => {
  const location = useLocation();
  const role = auth?.token?.split(" ")[0];

  if (allowed.includes(role)) {
    return <Outlet />;
  }

  if (!role) {
    return (
      <Navigate
        to={buildLoginPath(location.pathname, location.search)}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Navigate to="/" replace />;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ProtectedRoute);
